export const noop = Object.assign(() => {}, { async: async () => {} })
